import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EsignStatus } from '/@/modules/esign/constants/EsignStatus';
import { ModelType } from '/@/modules/core/app/constants/ModelType';

export class EsignEnvelopeEstateAccount extends BaseEntityModel {
  /**
   * @var {number}
   */
  esignEnvelopeId;

  /**
   * @var {number}
   */
  estateAccountId;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  email;

  /**
   * @var {number}
   */
  clientUserId;

  /**
   * @var {string}
   */
  status;

  /**
   * @var {boolean}
   */
  canRequestUrl;

  /**
   * @relationship {EstateAccount}
   */
  estateAccount;

  /**
   * @relationship {EsignEnvelope}
   */
  esignEnvelope;

  constructor(model = {}) {
    super(model);
    super.setRelationships(this, model, this.getModelName());

    this.esignEnvelopeId = model.esignEnvelopeId;
    this.estateAccountId = model.estateAccountId;
    this.name = model.name;
    this.email = model.email;
    this.clientUserId = model.clientUserId;
    this.status = model.status;
    this.canRequestUrl = model.canRequestUrl;
  }

  /**
   *
   * @returns {string}
   */
  getModelName() {
    return ModelType.ESIGN_ENVELOPE_ESTATE_ACCOUNT;
  }

  get id() {
    return `${this.esignEnvelopeId}-${this.estateAccountId}`;
  }

  /**
   * @returns {boolean}
   */
  get isCompleted() {
    return this.status === EsignStatus.COMPLETED.key;
  }

  /**
   * @returns {boolean}
   */
  get isSigned() {
    return this.status === EsignStatus.SIGNED.key;
  }

  /**
   * @returns {boolean}
   */
  get isSignedOrCompleted() {
    return this.isSigned || this.isCompleted;
  }

  /**
   * @returns {boolean}
   */
  get isDistributionPlanType() {
    return this.esignEnvelope.isDistributionPlanType;
  }

  /**
   * @returns {boolean}
   */
  get isInterimDistributionReleaseType() {
    return this.esignEnvelope.isInterimDistributionReleaseType;
  }

  /**
   * @returns {*}
   */
  get displayStatus() {
    return EsignStatus.getByKey(this.status);
  }
}
